import { ASSESSMENT_SUPERCATEGORY_TYPES } from "@sscs/report/constants";
import { SDLCMetadata } from "@sscs/types";

export type CategoryComparison = "worsened" | "improved" | "unchanged";

const STATUS_SEVERITY: Record<SDLCMetadata.assessment_status_t, number> = {
  pass: 0,
  warning: 1,
  fail: 2,
};

export const compareCategoryStatus = (
  current: SDLCMetadata.risk_assessment_t,
  previous: SDLCMetadata.risk_assessment_t,
): CategoryComparison => {
  const delta =
    STATUS_SEVERITY[current.status] - STATUS_SEVERITY[previous.status];

  if (delta > 0) return "worsened";
  if (delta < 0) return "improved";

  return "unchanged";
};

export type ComparisonSummary = {
  worsened: number;
  improved: number;
  unchanged: number;
};

const ALL_CATEGORIES: SDLCMetadata.assessment_type_t[] = Object.values(
  ASSESSMENT_SUPERCATEGORY_TYPES,
).flat();

export const summarizeComparison = (
  current: SDLCMetadata.risk_object_t,
  previous: SDLCMetadata.risk_object_t,
): ComparisonSummary =>
  ALL_CATEGORIES.reduce<ComparisonSummary>(
    (summary, category) => {
      const currentAssessment = current[category];
      const previousAssessment = previous[category];

      if (!currentAssessment.enabled || !previousAssessment.enabled) {
        return summary;
      }

      const comparison = compareCategoryStatus(
        currentAssessment,
        previousAssessment,
      );

      return { ...summary, [comparison]: summary[comparison] + 1 };
    },
    { worsened: 0, improved: 0, unchanged: 0 },
  );

export type QualityChange = "worsened" | "improved";

export const deriveQualityChange = (
  summary: ComparisonSummary,
): QualityChange | undefined => {
  if (summary.worsened > 0) return "worsened";
  if (summary.improved > 0) return "improved";

  return undefined;
};
